import { html, isTextSelected, onDelegatedClick, setLoading, swalAlert } from '../functions.js';

export default class WaitinglistFormElement extends HTMLElement {

    #form = null;
    #thanks = null;
    #errorMessage = null;
    #formGroup = null;

    connectedCallback() {

        this.#form = this.querySelector('form');
        this.#thanks = this.querySelector('.waitinglist__thanks');

        this.#errorMessage = this.querySelector('.error-message');
        this.#formGroup = this.querySelector('.waitinglist__formgroup');
        
        this.#form.addEventListener('submit', event => {
            this.#onSubmit(event);
        });

    }

    #onSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        this.#clearErrors();

        let formData = new FormData(this.#form);

        let url = this.#form.action;

        setLoading(this.#form, true);

        fetch(url, { method: 'POST', body: formData })
            .then(res => res.json())
            .then(res => {
                setLoading(this.#form, false);

                if (res.result === 1) {

                    this.#form.style.display = 'none';
                    this.#thanks.style.display = 'block';

                } else if (res.msg) {
                    this.#formGroup.classList.add('has-error');
                    this.#errorMessage.innerText = res.msg;
                    this.#errorMessage.style.display = 'block';

                } else {
                    swalAlert('An error occurred');
                }
            })
            .catch(error => {
                setLoading(this.#form, false);
                swalAlert(error.message);
            });

    }

    #clearErrors() {
        this.#errorMessage.style.display = 'none';
        this.#formGroup.classList.remove('has-error');
    }

    show(slotId) {

        this.#clearErrors();

        this.#thanks.style.display = 'none';
        this.#form.style.display = 'block';
        this.querySelector('input[name="email"]').value = '';

        this.querySelector('input[name="slot_id"]').value = slotId;

        customElements.whenDefined('sl-dialog').then(() => {
            this.querySelector('sl-dialog').show().then(() => {
                this.querySelector('input[name="email"]').focus();
            });
            
        });
    }
}
window.customElements.define('waitinglist-form', WaitinglistFormElement);

